import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { useAuth } from "../lib/AuthContext";
import { BarChart3, Clock3, Home, LogIn, LogOut, ScanSearch, Sparkles } from "lucide-react";

const NAV_ITEMS = [
  { to: "/", label: "Tổng quan", icon: Home },
  { to: "/plagiarism", label: "Kiểm tra đạo văn", icon: ScanSearch },
  { to: "/ai", label: "Kiểm tra AI", icon: Sparkles },
  { to: "/history", label: "Lịch sử", icon: Clock3 },
];

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <aside className="app-sidebar">
      <div className="app-sidebar-inner">
        <div className="sidebar-brand-block">
          <Link to="/" className="sidebar-brand">
            <div className="sidebar-brand-mark">
              <BarChart3 className="h-5 w-5" />
            </div>
            <div>
              <div className="sidebar-brand-title">Checker</div>
              <div className="sidebar-brand-subtitle">AI & Plagiarism Suite</div>
            </div>
          </Link>
          <div className="sidebar-badge">Nền tảng học thuật thông minh</div>
        </div>

        <nav className="sidebar-nav" aria-label="Điều hướng chính">
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            const isActive =
              item.to === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(item.to);

            return (
              <Link
                key={item.to}
                to={item.to}
                className={`sidebar-link ${isActive ? "sidebar-link-active" : ""}`}
              >
                <Icon className="h-4 w-4" />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="sidebar-panel">
          <div className="sidebar-panel-title">Gợi ý nhanh</div>
          <p className="sidebar-panel-text">
            Tải nội dung lên để kiểm tra mức độ tương đồng, dấu hiệu AI và lưu lịch sử báo cáo.
          </p>
        </div>

        <div className="sidebar-footer">
          {isAuthenticated ? (
            <Button variant="outline" size="sm" className="w-full justify-start" onClick={handleLogout}>
              <LogOut className="mr-2 h-4 w-4" />
              Đăng xuất
            </Button>
          ) : (
            <Link to="/login" className="w-full">
              <Button variant="outline" size="sm" className="w-full justify-start">
                <LogIn className="mr-2 h-4 w-4" />
                Đăng nhập
              </Button>
            </Link>
          )}
        </div>
      </div>
    </aside>
  );
};

export default Header;
